import { LinearProgress } from "@material-ui/core";
import React from "react";
import Select, { components } from "react-select";
import { ReactComponent as SearchIcon } from "../../../../assets/searchIcon.svg";
import useSelectStyles, { indicatorStyles } from "./Select/themes";
type option = { label: string; value: string };

type TElements = {
  id: string;
  name: string;
  startdate: string;
  enddate: string;
  periodlevel: string;
  "scorecard.name"?: string | undefined;
}[];

type Props = {
  elements: TElements;
  label?: string;
  isMulti?: boolean;
  dir?: string;
  placeholder?: string;
  name: string;
  value?: option;
  isSearchable?: boolean;
  isAsync?: boolean;
  options?: option[];
  onElementSelected: (val: any) => any;
};

const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <SearchIcon />
    </components.DropdownIndicator>
  );
};

const ext = {
  optionsCallback: (options: any) => {},
};

type NavItem = {
  link: string;
  title: string;
  children?: Array<NavItem>;
};

type SelectItem = {
  value: string;
  label: string;
};

const ElementSelect = (props: Props) => {
  const classes = useSelectStyles();
  const { label, isSearchable } = props;
  const [searchText, setSearchText] = React.useState("");

  const options = React.useMemo<SelectItem[]>(() => {
    return props.elements
      .map((item) => {
        const scname = item["scorecard.name"] || "unknown";
        return {
          value: item.id,
          label: `${item.name} [${scname}]`,
        };
      })
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [props.elements]);

  if (!props.elements.length) {
    return (
      <div
        style={{ width: "100%", height: "2px", padding: "20px 0px 20px 0px" }}
      >
        <LinearProgress />
      </div>
    );
  }

  return (
    <>
      {label !== (null || undefined) ? (
        <p className={classes.label}>{label}</p>
      ) : null}

      <Select
        styles={{
          indicatorsContainer: isSearchable ? indicatorStyles : undefined,
          indicatorSeparator: (base: any) => ({ ...base, display: "none" }),
          control: (base: any) => ({
            ...base,
            height: "43px",
            borderRadius: "6px",
            alignItems: "center",
            cursor: isSearchable ? "text" : "pointer",
          }),
        }}
        options={options}
        components={isSearchable ? { DropdownIndicator } : undefined}
        className={classes.select}
        onChange={(e: any) => {
          props.onElementSelected(e);
        }}
        {...props}
      />
    </>
  );
};

export default ElementSelect;
